// eslint-disable-next-line import/prefer-default-export
export enum EConsultantNewArticleResponseStatus {
  SUCCESS = 'Page created',
}
